import { forwardRef } from 'react';
import { FormControl, FormHelperText, FormLabel, Slider } from '@mui/material';
import { SystemColors } from 'melp-design/style';

interface Props {
  value: number;
  onChange: (value: number) => void;
  label?: string;
  name?: string;
  disabled?: boolean;
  min?: number;
  max?: number;
  step?: number;
  error?: string;
  infoMessage?: string;
}

export const SliderInput = forwardRef<HTMLSpanElement, Props>(
  (
    {
      value,
      onChange,
      label,
      name,
      disabled,
      min = 0,
      max = 100,
      step,
      error,
      infoMessage,
    },
    forwardedRef,
  ) => {
    return (
      <FormControl fullWidth error={!!error} disabled={disabled}>
        {label ? (
          <FormLabel
            component="legend"
            id={name}
            sx={{
              fontSize: 14,
              color: SystemColors.grey[45],
            }}
          >
            {label}
          </FormLabel>
        ) : null}

        <Slider
          size="small"
          valueLabelDisplay="on"
          sx={{
            '& .MuiSlider-markLabel': {
              top: 22,
            },
          }}
          marks={[
            { value: min, label: min },
            { value: max, label: max },
          ]}
          value={value}
          onChange={(_e, v) => {
            if (typeof v === 'number') {
              onChange(v);
            }
          }}
          name={name}
          disabled={disabled}
          min={min}
          max={max}
          step={step}
          ref={forwardedRef}
        />

        {error ? (
          <FormHelperText
            error
            sx={{ fontSize: 12, letterSpacing: 'inherit', mx: 0 }}
          >
            {error}
          </FormHelperText>
        ) : null}

        {infoMessage ? (
          <FormHelperText
            error={false}
            sx={{
              color: SystemColors.grey[45],
              fontSize: 12,
              letterSpacing: 'inherit',
              mx: 0,
            }}
          >
            {infoMessage}
          </FormHelperText>
        ) : null}
      </FormControl>
    );
  },
);

SliderInput.displayName = 'SliderInput';
